export const GET_NOTIFICATION_DATA_REQUEST = "GET_NOTIFICATION_DATA_REQUEST";
export const GET_NOTIFICATION_DATA_SUCCESS = "GET_NOTIFICATION_DATA_SUCCESS";
export const GET_NOTIFICATION_DATA_FAILURE = "GET_NOTIFICATION_DATA_FAILURE";

export const UPDATE_NOTIFICATION_REQUEST = "UPDATE_NOTIFICATION_REQUEST";
export const UPDATE_NOTIFICATION_SUCCESS = "UPDATE_NOTIFICATION_SUCCESS";
export const UPDATE_NOTIFICATION_FAILURE = "UPDATE_NOTIFICATION_FAILURE";

export const GET_CLIENT_BY_ID_REQUEST = "GET_CLIENT_BY_ID_REQUEST";
export const GET_CLIENT_BY_ID_SUCCESS = "GET_CLIENT_BY_ID_SUCCESS";
export const GET_CLIENT_BY_ID_FAILURE = "GET_CLIENT_TYPE_BY_ID_FAILURE";

export const UPDATE_NOTIFICATION_DATA_ENTITY_PARAMS_SUCCESS =
    "UPDATE_NOTIFICATION_DATA_ENTITY_PARAMS_SUCCESS";
export const UPDATE_NOTIFICATION_DATA_ENTITY_PARAMS_FAILURE =
    "UPDATE_NOTIFICATION_DATA_ENTITY_PARAMS_FAILURE";

export const GET_LIST_FOR_COMMON_FILTER_REQUEST = "GET_LIST_FOR_COMMON_FILTER_REQUEST";
export const GET_LIST_FOR_COMMON_FILTER_SUCCESS = "GET_LIST_FOR_COMMON_FILTER_SUCCESS";
export const GET_LIST_FOR_COMMON_FILTER_FAILURE = "GET_LIST_FOR_COMMON_FILTER_FAILURE";

export const GET_NOTIFICATION_EXPORT_REQUEST = "GET_NOTIFICATION_EXPORT_REQUEST";
export const GET_NOTIFICATION_EXPORT_SUCCESS = "GET_NOTIFICATION_EXPORT_SUCCESS";
export const GET_NOTIFICATION_EXPORT_FAILURE = "GET_NOTIFICATION_EXPORT_FAILURE";

export const GET_UNREAD_NOTIFICATION_DATA_REQUEST = "GET_UNREAD_NOTIFICATION_DATA_REQUEST";
export const GET_UNREAD_NOTIFICATION_DATA_SUCCESS = "GET_UNREAD_NOTIFICATION_DATA_SUCCESS";
export const GET_UNREAD_NOTIFICATION_DATA_FAILURE = "GET_UNREAD_NOTIFICATION_DATA_FAILURE";

